import React from 'react';

import { AutomationReviewAndActiveTemplate } from '@hero/templates';

function NewAutomationReviewAndActivePage() {
  return <AutomationReviewAndActiveTemplate />;
}

export { NewAutomationReviewAndActivePage };
